export default [
  {title: '微笑'}, {title: '撇嘴'},
  {title: '色'}, {title: '发呆'},
  {title: '得意'}, {title: '流泪'},
  {title: '害羞'}, {title: '闭嘴'},
  {title: '睡'}, {title: '大哭'},
  {title: '尴尬'}, {title: '发怒'},
  {title: '调皮'}, {title: '呲牙'},
  {title: '惊讶'}, {title: '难过'},
  {title: '酷'}, {title: '冷汗'},
  {title: '抓狂'}, {title: '吐'},
  {title: '偷笑'}, {title: '愉快'},
  {title: '白眼'}, {title: '傲慢'},
  {title: '饥饿'}, {title: '困'},
  {title: '惊恐'}, {title: '流汗'},
  {title: '憨笑'}, {title: '悠闲'},
  {title: '奋斗'}, {title: '咒骂'},
  {title: '疑问'}, {title: '嘘'},
  {title: '晕'}, {title: '疯了'},
  {title: '衰'}, {title: '骷髅'},
  {title: '敲打'}, {title: '再见'},
  {title: '擦汗'}, {title: '抠鼻'},
  {title: '鼓掌'}, {title: '糗大了'},
  {title: '坏笑'}, {title: '左哼哼'},
  {title: '右哼哼'},
  {title: '哈欠'}, {title: '鄙视'},
  {title: '委屈'}, {title: '快哭了'},
  {title: '阴险'},
  {title: '亲亲'}, {title: '吓'},
  {title: '可怜'}, {title: '菜刀'},
  {title: '西瓜'}, {title: '啤酒'},
  {title: '篮球'}, {title: '乒乓'},
  {title: '咖啡'}, {title: '饭'},
  {title: '猪头'}, {title: '玫瑰'},
  {title: '凋谢'}, {title: '嘴唇'},
  {title: '爱心'}, {title: '心碎'},
  {title: '蛋糕'}, {title: '闪电'},
  {title: '炸弹'}, {title: '刀'},
  {title: '足球'}, {title: '瓢虫'},
  {title: '便便'}, {title: '月亮'},
  {title: '太阳'}, {title: '礼物'},
  {title: '拥抱'}, {title: '强'},
  {title: '弱'}, {title: '握手'},
  {title: '胜利'}, {title: '抱拳'},
  {title: '勾引'}, {title: '拳头'},
  {title: '差劲'}, {title: '爱你'},
  {title: 'NO'}, {title: 'OK'},
  {title: '爱情'}, {title: '飞吻'},
  {title: '跳跳'}, {title: '发抖'},
  {title: '怄火'}, {title: '转圈'},
  {title: '磕头'}, {title: '回头'},
  {title: '跳绳'}, {title: '投降'},
  {title: '激动'}, {title: '乱舞'},
  {title: '献吻'}, {title: '左太极'},
  {title: '右太极'}
]
